import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from '../../../node_modules/abp-ng2-module/dist/src/abpHttpInterceptor';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.FieldPhotoServiceProxy,
        ApiServiceProxies.AIPlatomServiceProxy,
        ApiServiceProxies.MetabaseDynamicServiceProxy,
        ApiServiceProxies.PredictResultServiceProxy,
        ApiServiceProxies.DynamicFormResultServiceProxy,
        ApiServiceProxies.DynamicFormManagementServiceProxy,
        ApiServiceProxies.StaffMapTrackingServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
